export default __webpack_public_path__ + "static/media/i_bstop.6c6eaca8.svg";